import React from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import Feather from 'react-native-vector-icons/Feather';
import { MB_Button } from '@/components/general/button';
import { MB_utilHooks } from '@/utils/general/util-hooks';
import { COLORS } from '../../../constants/colors';
import { textStyles } from '../../../constants/textStyles';
import { RESOURCE_POOL_TYPE } from '../../../typesAndInterfaces/typesAndInterfaces';
import { BulkUploadModal } from './BulkUploadModal';

/**
 * Entry point for the bulk upload flow. Lives next to the single-upload button on the
 * pool screens; the single-upload flow is untouched.
 */
const BulkUploadButton = ({ buttonStyle, resourcePoolType, folderId }: { buttonStyle?: StyleProp<ViewStyle>; resourcePoolType: RESOURCE_POOL_TYPE; folderId?: string }) => {
  const [isModalVisible, showModal, hideModal] = MB_utilHooks.useBool();

  return (
    <>
      <BulkUploadModal isVisible={isModalVisible} onDismiss={hideModal} resourcePoolType={resourcePoolType} folderId={folderId} />
      <MB_Button
        title={resourcePoolType === RESOURCE_POOL_TYPE.Image ? 'Bulk Upload Images' : 'Bulk Upload Videos'}
        onPress={showModal}
        leftElement={<Feather name="upload" color={COLORS.buttonPurple} size={14} />}
        textStyle={[textStyles.smallText, { color: COLORS.buttonPurple }]}
        style={[styles.button, buttonStyle]}
      />
    </>
  );
};

export { BulkUploadButton };

const styles = StyleSheet.create({
  button: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: COLORS.buttonPurple,
    width: 205,
    height: 38,
    borderRadius: 10,
  },
});
